module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hress1e"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.app.nowLang,
      "columns": _vm.columns[_vm.app.nowLang].index,
      "unLoadBool": true,
      "receivedStore": _vm.receivedHress1eIndex,
      "editEvent": _vm.editEvent,
      "searchBoxAlias": "hress1e"
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  }), _vm._v(" "), _c('detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "descCodapp": _vm.descCodapp,
      "labels": _vm.labels[_vm.app.nowLang],
      "labelsButton": _vm.app.button[_vm.app.nowLang],
      "nowLang": _vm.app.nowLang,
      "toggle": _vm.toggle,
      "indexSelected": _vm.indexSelected,
      "codempid": _vm.codempid,
      "descCodempid": _vm.app.currentUser.username[_vm.app.nowLang],
      "detail": _vm.detail,
      "dropdowns": _vm.dropdowns,
      "searchIndex": _vm.searchIndex,
      "detail1Columns": _vm.columns[_vm.app.nowLang].detail1Columns,
      "detail2Columns": _vm.columns[_vm.app.nowLang].detail2Columns,
      "postDetail2Save": _vm.postDetail2Save
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78671c16!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hress1e/component.vue
// module id = 3898
// module chunks = 1